export const SEARCH_FIELD: string = "Search";
export const JOBS_TITLE_FIELD: string = "JobsTitle";